(function () {
  'use strict';

  if (window.AofSharedChrome) return;

  /* ---- Announcement plate rotation (coin chrome) ----
     Payload contract: JSON string "s1~s2~s3~promoBlock" where promoBlock may
     hold several newline-separated promo lines; "|" inside a line splits the
     narrow-viewport two-line lockup. One global interval; nodes re-queried
     each tick so Theme Editor section reloads need no re-init. */
  let annIdx = 0;
  function annMessages() {
    const tag = document.querySelector('[data-ao-announcements]');
    if (!tag) return null;
    try {
      const raw = JSON.parse(tag.textContent);
      const parts = String(raw).split('~');
      const statics = parts.slice(0, 3).map((s) => s.trim()).filter(Boolean);
      const promos = (parts[3] || '').split(/\r?\n/).map((s) => s.trim()).filter(Boolean);
      return { all: statics.concat(promos), promos };
    } catch (error) {
      return null;
    }
  }
  let annPaused = false;
  function annTick() {
    if (annPaused) return;
    const msgs = annMessages();
    if (!msgs || !msgs.all.length) return;
    const plate = document.querySelector('.aof-plate');
    if (!plate) return;
    plate.classList.add('aof-plate--fading');
    setTimeout(() => {
      annIdx += 1;
      const rot = msgs.all[annIdx % msgs.all.length] || '';
      const rotParts = rot.split('|');
      const main = plate.querySelector('[data-ao-rotator-main]');
      const sub = plate.querySelector('[data-ao-rotator-sub]');
      if (main) main.textContent = rotParts[0].trim();
      if (sub) {
        if (rotParts[1]) {
          sub.textContent = rotParts[1].trim();
          sub.hidden = false;
        } else {
          sub.textContent = '';
          sub.hidden = true;
        }
      }
      if (msgs.promos.length) {
        const promoNode = plate.querySelector('[data-ao-promo]');
        if (promoNode) promoNode.textContent = (msgs.promos[annIdx % msgs.promos.length] || '').replace('|', ' ');
      }
      plate.classList.remove('aof-plate--fading');
    }, 450);
  }
  if (!window.__aoAnnTimer) window.__aoAnnTimer = setInterval(annTick, 4200);
  // Theme Editor: a re-rendered header starts from its first message and never inherits a half-finished fade.
  document.addEventListener('shopify:section:load', () => {
    annIdx = 0;
    document.querySelectorAll('.aof-plate--fading').forEach((plate) => plate.classList.remove('aof-plate--fading'));
  });
  // Theme Editor: hold the plate on its current message while the header section is being edited.
  document.addEventListener('shopify:section:select', (event) => {
    if (!event.target?.querySelector?.('.aof-plate')) return;
    annPaused = true;
    document.querySelectorAll('.aof-plate--fading').forEach((plate) => plate.classList.remove('aof-plate--fading'));
  });
  document.addEventListener('shopify:section:deselect', (event) => {
    if (event.target?.querySelector?.('.aof-plate')) annPaused = false;
  });


  const initializedRoots = new WeakSet();
  const rootControllers = new WeakMap();
  const cartEvents = ['cart:updated', 'cart:refresh', 'cart:update', 'product:added', 'aocdx:cart-updated'];
  let cartCountRevision = 0;

  function localizedCartUrl() {
    const root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    return `${root || '/'}cart.js`;
  }

  function renderedCartCount() {
    const state = document.querySelector('[data-ao-cart-v4] [data-ao-cart-v4-state]');
    if (!state) return null;
    const count = Number(state.dataset.visibleCount);
    return Number.isFinite(count) ? Math.max(0, count) : null;
  }

  function visibleCartCount(cart) {
    if (Array.isArray(cart?.items)) {
      return cart.items.reduce((count, item) => {
        if (item?.handle === 'shipping-protection') return count;
        return count + (Number(item?.quantity) || 0);
      }, 0);
    }
    return Number(cart?.item_count);
  }

  function applyCartCount(count) {
    const safeCount = Number.isFinite(Number(count)) ? Number(count) : 0;
    document.querySelectorAll('[data-aof-cart-count], [data-aocdx-cart-count]').forEach((node) => {
      node.textContent = String(safeCount);
    });
    document.querySelectorAll('[data-aof-cart-label], [data-aocdx-cart-label]').forEach((node) => {
      /* No aria-label here: the link's own visible text ("Cart · N") is the accessible name, which keeps
         the visible label and the accessible name identical for screen-reader and voice-control users. */
      node.removeAttribute('aria-label');
    });
  }

  function setCartCount(count) {
    cartCountRevision += 1;
    const renderedCount = renderedCartCount();
    applyCartCount(renderedCount === null ? count : renderedCount);
  }

  function refreshCartCount() {
    const renderedCount = renderedCartCount();
    if (renderedCount !== null) {
      setCartCount(renderedCount);
      return Promise.resolve({ item_count: renderedCount });
    }

    const requestRevision = ++cartCountRevision;
    return fetch(localizedCartUrl(), {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    })
      .then((response) => {
        if (!response.ok) throw new Error(`Cart request failed: ${response.status}`);
        return response.json();
      })
      .then((cart) => {
        if (requestRevision === cartCountRevision) applyCartCount(cart.item_count);
        return cart;
      })
      .catch(() => undefined);
  }

  function handleCartEvent(event) {
    const cart = event?.detail?.cart || event?.detail;
    if (cart && Number.isFinite(Number(cart.item_count))) {
      setCartCount(visibleCartCount(cart));
      return;
    }
    refreshCartCount();
  }

  function openCartDrawer(event) {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.open !== 'function') return;
    event.preventDefault();
    drawer.open(event.currentTarget);
  }

  const gccCountries = new Set(['SA', 'AE', 'KW', 'OM']);
  const localizationChoiceKey = 'ao-localization-choice-v1';
  const localizationAttemptKey = 'ao-gcc-localization-attempt-v1';
  let localizationStarted = false;
  let localizationChoice = { country: '', languages: {} };
  function localizationStorage(key, value) {
    try {
      if (value === null) window.sessionStorage.removeItem(key);
      else if (value !== undefined) window.sessionStorage.setItem(key, value);
      return window.sessionStorage.getItem(key);
    } catch (error) { return null; }
  }
  try {
    const saved = JSON.parse(localizationStorage(localizationChoiceKey) || 'null');
    if (saved && typeof saved.country === 'string' && saved.languages && typeof saved.languages === 'object') localizationChoice = saved;
  } catch (error) { /* A corrupt preference must not prevent native selection. */ }

  function initLocalization(root, signal) {
    const forms = Array.from(root.querySelectorAll('.ao-country-selector__form'));
    let submitted = false;
    let automaticForm = null;
    let manuallySelected = false;
    const hasOption = (select, value) => Array.from(select?.options || []).some((option) => option.value === value);
    const controls = forms.map((form) => ({ form, country: form.querySelector('[name="country_code"]'), language: form.querySelector('[name="language_code"]') }))
      .filter(({ country, language }) => country && language);

    controls.forEach(({ form, country, language }) => {
      const chooseLanguage = () => {
        const preference = localizationChoice.languages[country.value];
        if (hasOption(language, preference)) language.value = preference;
        else if (gccCountries.has(country.value) && hasOption(language, 'ar')) language.value = 'ar';
      };
      form.addEventListener('submit', (event) => {
        if (submitted) { event.preventDefault(); return; }
        if (form !== automaticForm) {
          manuallySelected = true;
          chooseLanguage();
          localizationChoice.country = country.value;
          localizationStorage(localizationChoiceKey, JSON.stringify(localizationChoice));
        }
        const returnTo = form.querySelector('[name="return_to"]');
        if (returnTo) returnTo.value = window.location.pathname + window.location.search + window.location.hash;
        submitted = true;
      }, { signal });
      country.addEventListener('change', () => {
        if (submitted) return;
        chooseLanguage();
        if (typeof form.requestSubmit === 'function') form.requestSubmit();
      }, { signal });
      language.addEventListener('change', () => {
        if (submitted) return;
        localizationChoice.languages[country.value] = language.value;
        localizationChoice.country = country.value;
        localizationStorage(localizationChoiceKey, JSON.stringify(localizationChoice));
        if (typeof form.requestSubmit === 'function') form.requestSubmit();
      }, { signal });
    });
    window.addEventListener('pageshow', () => { submitted = false; automaticForm = null; }, { signal });

    // A single native localization handoff for an unlocalized first entry.
    // Explicit locale URLs and manual choices always remain available.
    const primary = controls[0];
    if (!primary || localizationStarted) return;
    const { form, country, language } = primary;
    if (country.dataset.aoDesignMode === 'true' || window.Shopify?.designMode || signal.aborted) return;
    const currentCountry = country.dataset.aoCurrentCountry || country.value;
    const attempt = localizationStorage(localizationAttemptKey);
    // Clear only a completed Arabic handoff, never a failed English return.
    if (language.value.split('-')[0] === 'ar' && gccCountries.has(currentCountry) && (attempt === currentCountry || attempt === '1')) {
      localizationStorage(localizationAttemptKey, null);
    }
    const localeRoot = country.dataset.aoLocaleRoot || window.Shopify?.routes?.root || '/';
    if (localeRoot !== '/' || /^\/(?:ar|fr)(?:-[a-z]{2})?(?:\/|$)/i.test(window.location.pathname)) return;
    if (language.value.split('-')[0] !== 'en' || !hasOption(language, 'ar') || typeof form.requestSubmit !== 'function') return;
    if (!gccCountries.has(currentCountry) && localizationChoice.country) return;
    if (localizationChoice.languages[currentCountry] && localizationChoice.languages[currentCountry] !== 'ar') return;
    if (localizationStorage(localizationAttemptKey)) return;
    // If functional storage is unavailable, leave automatic routing off rather than risk a loop.
    if (localizationStorage(localizationAttemptKey, '1') !== '1') return;
    localizationStarted = true;

    const localize = (targetCountry) => {
      if (signal.aborted || submitted || manuallySelected || !gccCountries.has(targetCountry) || !hasOption(country, targetCountry)) return;
      const preferredLanguage = localizationChoice.languages[targetCountry];
      if (preferredLanguage && preferredLanguage !== 'ar') return;
      country.value = targetCountry;
      language.value = 'ar';
      localizationStorage(localizationAttemptKey, targetCountry);
      automaticForm = form;
      form.requestSubmit();
    };
    if (gccCountries.has(currentCountry)) { localize(currentCountry); return; }

    // Shopify's documented same-origin discovery API; no third-party IP lookup.
    const discovery = new AbortController();
    const abort = () => discovery.abort();
    signal.addEventListener('abort', abort, { once: true });
    const timeout = window.setTimeout(abort, 2000);
    fetch(`${window.Shopify?.routes?.root || '/'}browsing_context_suggestions.json?country[enabled]=true&language[enabled]=true`, {
      credentials: 'same-origin', headers: { Accept: 'application/json' }, signal: discovery.signal,
    }).then((response) => response.ok ? response.json() : null)
      .then((data) => {
        if (!discovery.signal.aborted) localize(data?.detected_values?.country?.handle || data?.suggestions?.[0]?.parts?.country?.handle);
      })
      .catch(() => undefined)
      .finally(() => { window.clearTimeout(timeout); signal.removeEventListener('abort', abort); });
  }

  function initHeader(root, signal) {
    const header = root.querySelector('[data-aof-header]');
    const toggle = root.querySelector('[data-aof-menu-toggle]');
    const menu = root.querySelector('[data-aof-mobile-menu]');
    if (!header || !toggle || !menu) return;

    initLocalization(root, signal);

    const closeMenu = (returnFocus) => {
      menu.hidden = true;
      toggle.setAttribute('aria-expanded', 'false');
      header.classList.remove('is-menu-open');
      if (returnFocus) toggle.focus();
    };

    const openMenu = () => {
      menu.hidden = false;
      toggle.setAttribute('aria-expanded', 'true');
      header.classList.add('is-menu-open');
      const firstLink = menu.querySelector('a');
      if (firstLink) firstLink.focus({ preventScroll: true });
    };

    toggle.addEventListener('click', () => {
      if (toggle.getAttribute('aria-expanded') === 'true') closeMenu(false);
      else openMenu();
    }, { signal });

    menu.querySelectorAll('a').forEach((link) => {
      link.addEventListener('click', () => closeMenu(false), { signal });
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && toggle.getAttribute('aria-expanded') === 'true') closeMenu(true);
    }, { signal });

    window.matchMedia('(min-width: 1000px)').addEventListener('change', (event) => {
      if (event.matches) closeMenu(false);
    }, { signal });

    let ticking = false;
    let scrollFrame = 0;
    const syncScrolledState = () => {
      header.classList.toggle('is-scrolled', window.scrollY > 8);
      ticking = false;
      scrollFrame = 0;
    };
    // The page starts at the top, so the scrolled state is false without reading layout. A scrollY read
    // here forces the document's first style+layout inside this task, before the rendering steps would
    // have done it and before the header offset below restyles the document again. Sync after load.
    if (document.readyState === 'complete') syncScrolledState();
    else window.addEventListener('load', syncScrolledState, { once: true, signal });
    window.addEventListener(
      'scroll',
      () => {
        if (ticking) return;
        ticking = true;
        scrollFrame = window.requestAnimationFrame(syncScrolledState);
      },
      { passive: true, signal }
    );
    signal.addEventListener('abort', () => {
      if (scrollFrame) window.cancelAnimationFrame(scrollFrame);
    }, { once: true });

    root.querySelectorAll('[data-aof-cart-trigger]').forEach((trigger) => {
      trigger.addEventListener('click', openCartDrawer, { signal });
    });
  }

  /* Sticky header offset contract: --aof-header-offset on <html> is the visible
     sticky bar (inner row + bottom rule, never the open mobile menu). Page CSS uses
     var(--aof-header-offset, 0px) for anchors and sticky columns; aof-shared.css
     holds the CSS fallback used before this runs. */
  function syncHeaderOffset() {
    const docStyle = document.documentElement.style;
    const inner = document.querySelector('[data-aof-shared-root].aof-shared-chrome--sticky-header .aof-header__inner');
    if (!inner || !inner.getClientRects().length) {
      docStyle.removeProperty('--aof-header-offset');
      return;
    }
    const header = inner.closest('[data-aof-header]');
    const rule = header ? parseFloat(window.getComputedStyle(header).borderBottomWidth) || 0 : 0;
    docStyle.setProperty('--aof-header-offset', `${Math.ceil(inner.getBoundingClientRect().height + rule)}px`);
  }

  function observeHeaderOffset(root, signal) {
    if (!root.classList.contains('aof-shared-chrome--sticky-header')) return;
    if (typeof window.ResizeObserver !== 'function') return;
    const inner = root.querySelector('.aof-header__inner');
    if (!inner) return;
    const observer = new window.ResizeObserver(syncHeaderOffset);
    observer.observe(inner);
    signal.addEventListener('abort', () => observer.disconnect(), { once: true });
  }

  function initRoot(root) {
    if (initializedRoots.has(root)) return;
    initializedRoots.add(root);
    const controller = new AbortController();
    rootControllers.set(root, controller);

    if (root.classList.contains('aof-shared-chrome--replace-theme-header')) {
      document.body.classList.add('aof-shared-header-active');
    }
    if (root.classList.contains('aof-shared-chrome--replace-theme-footer')) {
      document.body.classList.add('aof-shared-footer-active');
    }

    initHeader(root, controller.signal);
    // --aof-header-offset lives on <html>: writing it restyles every element. On phones nothing that is
    // visible at load depends on it, so the CSS fallback carries the first paint and the measured value (and
    // the ResizeObserver) land after load. On wider viewports the sticky purchase column is already stuck at
    // top: var(--aof-header-offset) when the page first paints, so a late write would shift it: measure now.
    if (document.readyState === 'complete' || window.matchMedia('(min-width: 750px)').matches) observeHeaderOffset(root, controller.signal);
    else window.addEventListener('load', () => observeHeaderOffset(root, controller.signal), { once: true });
  }

  function destroyRoot(root) {
    const controller = rootControllers.get(root);
    if (controller) controller.abort();
    rootControllers.delete(root);
    initializedRoots.delete(root);

    if (root.classList.contains('aof-shared-chrome--replace-theme-header')) {
      const hasAnotherHeader = Array.from(document.querySelectorAll('[data-aof-shared-root].aof-shared-chrome--replace-theme-header'))
        .some((candidate) => candidate !== root);
      if (!hasAnotherHeader) document.body.classList.remove('aof-shared-header-active');
    }
    if (root.classList.contains('aof-shared-chrome--replace-theme-footer')) {
      const hasAnotherFooter = Array.from(document.querySelectorAll('[data-aof-shared-root].aof-shared-chrome--replace-theme-footer'))
        .some((candidate) => candidate !== root);
      if (!hasAnotherFooter) document.body.classList.remove('aof-shared-footer-active');
    }
    // Theme Editor unload: re-measure once the old header has left the DOM (a reloaded header re-observes itself).
    if (root.classList.contains('aof-shared-chrome--sticky-header')) window.requestAnimationFrame(syncHeaderOffset);
  }

  function forEachRoot(scope, callback) {
    const base = scope && scope.querySelectorAll ? scope : document;
    if (base.matches && base.matches('[data-aof-shared-root]')) callback(base);
    base.querySelectorAll('[data-aof-shared-root]').forEach(callback);
  }

  function initAll(scope) {
    forEachRoot(scope, initRoot);
  }

  function destroyAll(scope) {
    forEachRoot(scope, destroyRoot);
  }

  cartEvents.forEach((eventName) => document.addEventListener(eventName, handleCartEvent));

  const cartBubble = document.getElementById('cart-icon-bubble');
  if (cartBubble) {
    new MutationObserver(refreshCartCount).observe(cartBubble, { childList: true, subtree: true, characterData: true });
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  document.addEventListener('shopify:section:unload', (event) => destroyAll(event.target));

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initAll(document);
      refreshCartCount();
    });
  } else {
    initAll(document);
    refreshCartCount();
  }

  window.AofSharedChrome = { init: initAll, refreshCartCount, setCartCount };
})();
